import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate, useOutlet } from 'react-router-dom';
import styled from 'styled-components';
import { appPaths } from 'consts/paths/paths';
import { AppMenu, AppMenuProps } from 'components/atoms';
import { settingsTexts } from 'consts/text';

const StyledAppMenu = styled(AppMenu)`
    width: max-content;
    margin: auto;
`;

export type DietMenuItem = {
    key: string;
    label: string;
};

export const settingsDietsNavBarOptions: DietMenuItem[] = [
    {
        key: appPaths.app.settings.diets.base,
        label: settingsTexts.diets.dietListTitle,
    },
    {
        key: appPaths.app.settings.diets.mealTypes.base,
        label: settingsTexts.diets.mealTypesTitle,
    },
];

export const SettingsDietsLayout = () => {
    const navigate = useNavigate();
    const outlet = useOutlet();
    const { pathname } = useLocation();

    const onMenuItemClick: AppMenuProps['onClick'] = ({ key }) => navigate(key);

    useEffect(() => {
        if (!outlet) {
            navigate(appPaths.app.settings.diets.base);
        }
    }, [navigate, outlet]);

    return (
        <>
            <StyledAppMenu
                mode="horizontal"
                items={settingsDietsNavBarOptions}
                selectedKeys={[pathname]}
                onClick={onMenuItemClick}
            />
            <Outlet />
        </>
    );
};
